import { Dialog } from '@dustess/cf-design-mobile';
import { DialogAction } from '@dustess/cf-design-mobile/lib/dialog/types';
import AuthSdk from '@markting/mk-wx-auth';

const urlEncode = (param: any, encode = false, key: number | string) => {
  if (param === null) return '';
  let paramStr = '';
  const t = typeof param;
  if (['string', 'number', 'boolean'].includes(t)) {
    paramStr += `&${key}=${encode ? encodeURIComponent(param) : param}`;
  } else {
    for (const i in param) {
      const k = key ? key + (param instanceof Array ? '[' + i + ']' : '.' + i) : i;
      paramStr += urlEncode(param[i], encode, k);
    }
  }

  return paramStr;
};

const deleteOtherUrlParams = (globalProperties: any) => {
  const defaultKeys = ['code', 'appId', 'appid', 'state'];
  const _urlObj = JSON.parse(JSON.stringify(globalProperties.$urlObj));
  defaultKeys.forEach(key => {
    delete _urlObj[key];
  });
  const { href } = location;
  const params = urlEncode(_urlObj, false, '').substring(1);
  const newHref = href.split('?')[0] + (params ? `?${params}` : '');
  // 更改 url 地址，防止刷新页面时 code 失效
  window.history.replaceState({ status: 0 }, '', newHref);
};

/** 是否需要授 */
export const getIsNeedAuth = (globalProperties: any) => {
  const { $getAuthUserInfo, util } = globalProperties;
  const authUserInfo = $getAuthUserInfo();
  const needAuth = util.storage.getItem('isNeedLogin');
  console.log('filter--authUserInfo', authUserInfo);
  // url链接上携带了 code 参数，说明是从授权页面跳转过来的 默认为不需要授权了
  if (globalProperties.$urlObj.code) return false;
  // 页面需要登录 且 本地没有用户信息 需要授权
  return needAuth && !authUserInfo?.wxUserInfo?.unionid;
};

/**
 * 授权
 * @param globalProperties 全局数据
 * @param showDialog 是否弹窗
 * @returns
 */
export const handleAuth = async (globalProperties: any, showDialog = false) => {
  const { $getAuthUserInfo, util } = globalProperties;
  const authUserInfo = $getAuthUserInfo();

  // 是否需要授权
  const needAuth = util.storage.getItem('isNeedLogin');
  if (authUserInfo?.wxUserInfo?.unionid || !needAuth) return;

  const auth = async () => {
    await AuthSdk(globalProperties.$urlObj.account, (data) => {
      console.log('filter--AuthSdk', data);
    }, false, false);
  };

  // url 是否有 code 参数
  if (globalProperties.$urlObj.code) {
    // 有 code 参数，调用 AuthSdk 去获取会话信息 完成后更改 url 参数
    await auth();
    deleteOtherUrlParams(globalProperties);
  } else {
    // 无 code 参数，还是调用 AuthSdk 去授权重定向
    if (showDialog) {
      Dialog.confirm({
        message: '当前页面需授权后才可查看全部内容，点击下方「去授权」按钮可完成授权',
        showCancelButton: false,
        confirmButtonText: '去授权',
        beforeClose: (action: DialogAction, done: any) => {
          console.log('action', action, done);
          const { wxUserInfo } = $getAuthUserInfo() || {};
          if (wxUserInfo?.unionid) {
            return true;
          }
          // 无 code 去授权获取 code
          auth();
        }
      });
    } else {
      auth();
    }
  }
};
